
const enviornment = 'prod'; // prod/uat/dev

let api;
if (enviornment === 'uat') {
    api = {
        validatetoken: 'https://m3lne82ci6.execute-api.ap-south-1.amazonaws.com/default/validatetoken',
        getusercount: 'https://fn1s5ch3w0.execute-api.ap-south-1.amazonaws.com/default/getusercount',
        verify_nominee_optout: "https://m3lne82ci6.execute-api.ap-south-1.amazonaws.com/default/verify_nominee_optout",

        x_api_key: 'q060lDAUX55Ouw5PHOpR6igeiXnXvli3VRmgfZW9',
        // authorizationToken: 'M716Cq1I2qDUTh1z',
        usercount: true
    }
}

if (enviornment === 'prod') {
    api = {
        validatetoken: 'https://aq80fawqof.execute-api.ap-south-1.amazonaws.com/default/validatetoken',
        getusercount: 'https://kibdc3r4gf.execute-api.ap-south-1.amazonaws.com/default/getusercount',
        verify_nominee_optout: "https://aq80fawqof.execute-api.ap-south-1.amazonaws.com/default/verify_nominee_optout",

        x_api_key: '1TGNsS0Li58n2kEJIqhHI9Qfi93oEkq93sNkEJ78',
        // authorizationToken: 'nYB3odfPm6oFR3v2',
        usercount: false
    }
}

export default api;